import { render, staticRenderFns } from "./DoctorCardDropdown.vue?vue&type=template&id=6a408170"
import script from "./DoctorCardDropdown.vue?vue&type=script&lang=js"
export * from "./DoctorCardDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports